// google tag manager offline
function getExpiryRecord(value) {
	let expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds
	let expiryDate = new Date().getTime() + expiryPeriod;
	let val = {
		value: value,
		expiryDate: expiryDate
	};
	return val;
}

function getParam(p) {
	let match = RegExp("[?&]" + p + "=([^&]*)").exec(window.location.search);
	return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

function getClientID() {
	try {
		let trackers = ga.getAll();
		let i, len;
		for (i = 0, len = trackers.length; i < len; i += 1) {
			if (trackers[i].get("trackingId") === "UA-22375430-1") {
				return trackers[i].get("clientId");
			}
		}
	} catch (e) {}
	return "missing";
}

function addGclid() {
	let gclidParam = getParam("gclid");
	let cid = getClientID();
	let gclidFormFields = ["gclid_field"];
	let gclidRecord = null;
	let currGclidFormField;
	let cidField;
	if (document.getElementById("cid_field")) {
		cidField = document.getElementById("cid_field");
	}
	let gclsrcParam = getParam("gclsrc");
	let isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf("aw") !== -1;
	gclidFormFields.forEach(function(field) {
		if (document.getElementById(field)) {
			currGclidFormField = document.getElementById(field);
		}
	});
	if (gclidParam && isGclsrcValid) {
		gclidRecord = getExpiryRecord(gclidParam);
		localStorage.setItem("gclid", JSON.stringify(gclidRecord));
	}
	let gclid = gclidRecord || JSON.parse(localStorage.getItem("gclid"));
	let isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;
	if (currGclidFormField && isGclidValid) {
		currGclidFormField.value = gclid.value;
	}
	if (cidField) {
		cidField.value = cid;
	}
}
window.addEventListener("load", addGclid);
